"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _textInputBase = _interopRequireDefault(require("./text-input-base"));
var _styles = require("./styles");
// eslint-disable-next-line react/display-name
const Input = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  return /*#__PURE__*/_react.default.createElement(_textInputBase.default, props, TextInputProps => {
    return /*#__PURE__*/_react.default.createElement(_styles.StyledInput, (0, _extends2.default)({
      ref: ref,
      type: "text"
    }, TextInputProps));
  });
});
Input.propTypes = {
  ..._textInputBase.default.propTypes
};
Input.defaultProps = {
  ..._textInputBase.default.defaultProps
};
var _default = exports.default = Input;
Input.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Input",
  "composes": ["./text-input-base"]
};